import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SearchbarStyle from './css/SearchbarStyle'
import CloseButton from '../close_button/CloseButton'

function Searchbar(props) {
  const { search, setSearch, filter } = props
  const [keyPressed, setKeyPressed] = useState('')
  const [displayCancelSearchButton, setDisplayCancelSearchButton] = useState('none')
  const searchRef = useRef(null)

  const onChange = (e) => {
    // If keypressed is unwnanted keys then return
    if (!keyPressed) return

    setSearch(e.target.value)

    // Hide/Show cancel (x) button
    if (e.target.value)
      setDisplayCancelSearchButton('flex')
    else {
      setDisplayCancelSearchButton('none')
      filter('')
    }
  }

  const onKeyUp = (e) => (e.key === 'Enter') ? filter(search) : null

  const onKeyDown = (e) => {
    // unwanted keys to avoid conflict with regular expression
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      default:
        setKeyPressed(e.key)
    }
  }

  const onCancelSearchButton = (e) => {
    e.preventDefault()
    setSearch('')
    setDisplayCancelSearchButton('none')
    filter('')
    document.getElementById('search').focus()
  }

  useEffect(() => searchRef.current.focus(), [] )

  return (
    <React.Fragment>
      <div className={search ? 'search-control-container search-control-container-shadow' : 'search-control-container'}>
        <div className='spyglass-container'>
          <FontAwesomeIcon icon='search'/>
        </div>
        <input
          autoComplete='off'
          id="search"
          ref={searchRef}
          type="text"
          placeholder="Search..."
          onChange={onChange}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          value={search || ''}
          className='top-anchor'
        />
        <div style={{display: displayCancelSearchButton}}>
          <CloseButton onClick={onCancelSearchButton} />
        </div>
      </div>
      <SearchbarStyle />
    </React.Fragment>
  )
}

export default React.memo(Searchbar)
